import { useWsmFitmentSchemaCreateMutation } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import useNotifier from "@dashboard/hooks/useNotifier";
import { commonMessages } from "@dashboard/intl";
import React from "react";
import { useIntl } from "react-intl";

import { addToWsmFitmentList } from "../cache";
import WsmFitmentSchemaDetailsPage from "../components/WsmFitmentSchemaDetailsPage";
import { useWsmFitmentAxes, useWsmFitmentSchemas } from "../hooks/useWsmFitmentVocabulary";
import { schemaMessages } from "../messages";
import { wsmFitmentSchemaUrl } from "../urls";
import { emptySchemaFormData, getSchemaInput, getWriteState } from "../utils";

export const WsmFitmentSchemaCreateView = () => {
  const intl = useIntl();
  const navigate = useNavigator();
  const notify = useNotifier();
  const { axes, loading: axesLoading } = useWsmFitmentAxes();

  // Mounted so the refetch below reaches it: refetch-by-name skips an unmounted query.
  useWsmFitmentSchemas();

  const [createSchema, createSchemaOpts] = useWsmFitmentSchemaCreateMutation({
    // Payload errors render on the form; a toast would say them twice.
    disableNestedErrorHandling: true,
    // The detail screen reads its row from the list: put it there before navigating.
    update: (cache, { data }) => {
      const schema = data?.wsmFitmentSchemaCreate?.schema;

      if (schema && !data?.wsmFitmentSchemaCreate?.errors.length) {
        addToWsmFitmentList(cache, "wsmFitmentSchemas", schema);
      }
    },
    refetchQueries: ["WsmFitmentSchemas"],
    awaitRefetchQueries: true,
    onCompleted: result => {
      const schema = result.wsmFitmentSchemaCreate?.schema;

      if (schema && !result.wsmFitmentSchemaCreate?.errors.length) {
        notify({ status: "success", text: intl.formatMessage(commonMessages.savedChanges) });
        navigate(wsmFitmentSchemaUrl(schema.id));
      }
    },
  });
  const payload = createSchemaOpts.data?.wsmFitmentSchemaCreate;

  return (
    <WsmFitmentSchemaDetailsPage
      title={intl.formatMessage(schemaMessages.create)}
      axes={axes}
      axesLoading={axesLoading}
      initialData={emptySchemaFormData()}
      errors={payload?.errors ?? []}
      disabled={createSchemaOpts.loading}
      saveButtonBarState={getWriteState(createSchemaOpts, payload)}
      onSubmit={formData => createSchema({ variables: { input: getSchemaInput(formData) } })}
    />
  );
};

export default WsmFitmentSchemaCreateView;
